<template>
  <div class="main-container">
    <Button type="primary" class="btn export" @click="exportDetailData">导出</Button>
    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>
    <div class="title">
      <span>{{ $route.query.title }}</span>
    </div>
    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData"> </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  data() {
    return {
      total: 0,
      tableData: [],
      columns: [
        {
          title: '费用归属/机构',
          align: 'center',
          key: 'owerName',
          minWidth: 200
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          fixed: 'left',
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            if (params.row.sellType.includes('1')) {
              return <Tag color="blue">网销</Tag>;
            } else if (params.row.sellType.includes('3')) {
              return <Tag color="blue">经代</Tag>;
            }
          }
        },
        {
          title: '保费(元)',
          align: 'center',
          key: 'fee',
          minWidth: 150
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'commissionType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1 || commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }
          }
        },
        {
          title: '净费率',
          align: 'center',
          key: 'netCommission',
          minWidth: 100,
          render(h, params) {
            const netCommission = params.row.netCommission;
            return <span>{netCommission ? netCommission + '%' : '-'}</span>;
          }
        },
        {
          title: '净收入',
          align: 'center',
          key: 'netIncome',
          minWidth: 120
        }
      ]
    };
  },

  activated() {
    this.getList();
    this.setPageTitle(this.$route.query.title);
  },

  methods: {
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/settlementData/read/page',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          reportId: this.$route.query.reportId,
          owerId: this.$route.query.orgId
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 导出
    exportDetailData() {
      if (!this.$units.pointAction('offline_82_3_5')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let { reportId, orgId } = this.$route.query;
      this.$units.downloadFile('/buz/settlementData/export', { reportId, owerId: orgId }, 'POST');
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
}
.tableBox {
  margin-top: 20px;
}
.export {
  position: absolute;
  right: 100px;
}
.back-btn {
  position: absolute;
  right: 20px;
}
</style>
